import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  public token: any;
  constructor(
      public router: Router,
      public activeRoute: ActivatedRoute
  ) { }
  canActivate(){
    if(localStorage.getItem('currentUser')) {
      return true;
    }
    this.router.navigate(['']);
    return false;
  }
  
}
